import Splide from '@splidejs/splide';
import gsap from 'gsap';

export default function carouselFeatures() {

    // Try to find the wrapper first
    const carousels = document.querySelectorAll('.carousel-features');

    if (carousels.length > 0) {
        carousels.forEach(carousel => {
            const imageWrapper = carousel.querySelector('.carousel-features__images');
            const contentWrapper = carousel.querySelector('.carousel-features__contents');

            if (imageWrapper && contentWrapper) {
                initCarousel(imageWrapper, contentWrapper, carousel);
            }
        });
    }

}

function initCarousel(imageWrapper, contentWrapper, wrapper) {
    
    const imageElement = imageWrapper.querySelector('.splide');
    const contentElement = contentWrapper.querySelector('.splide');

    const bgColors = ['var(--color-neutral-500)', 'var(--color-green)', 'var(--color-gold)', 'var(--color-red)'];

    if (!imageElement || !contentElement) return;

    // Image Slider (Fade)
    const splideImage = new Splide(imageElement, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
        drag: false,
        start: 0,
    });

    // Content Slider (Regular)
    const splideContent = new Splide(contentElement, {
        // type: 'loop',
        pagination: false,
        arrows: false,
        focus: 'center',
        perPage: 3,
        padding: { left: 0, right: 40 },
        breakpoints: {
            1024: {
                focus: 'left',
                perPage: 2,
                padding: { left: 0, right: 60 },
            },
            640: {
                focus: 'left',
                perPage: 1,
                padding: { left: 0, right: 60 },
            },
        },
    });

    // Mount both
    splideImage.mount();
    splideContent.mount();

    const bgElement = wrapper.querySelector('.block__wrapper');

    // console.log(bgElement);

    // Default state: Images hidden
    imageWrapper.style.opacity = '0';
    imageWrapper.style.transition = 'opacity 0.6s ease';
    imageWrapper.style.pointerEvents = 'none';
    bgElement.style.transition = 'background-color 0.6s ease';

    // Add hover listeners to content slides
    const slides = splideContent.Components.Slides;

    slides.forEach(Slide => {
        Slide.slide.addEventListener('mouseenter', () => {
            // Show images
            imageWrapper.style.opacity = '1';
            // Change background color based on slide index
            const color = bgColors[Slide.index % bgColors.length];
            bgElement.style.backgroundColor = color;

            // Switch image slider to the corresponding index
            // Slide.index is the 0-based index of the slide
            splideImage.go(Slide.index);

            // Blur other slides
            slides.forEach(otherSlide => {
                const glass = otherSlide.slide.querySelector('.carousel-features__glass');
                if (glass) {
                    if (otherSlide.index !== Slide.index) {
                        glass.classList.add('is-blurred');
                    } else {
                        glass.classList.remove('is-blurred');
                    }
                }
            });
        });
    });

    // Hide images when mouse leaves the content area
    contentWrapper.addEventListener('mouseleave', () => {
        imageWrapper.style.opacity = '0';
        bgElement.style.backgroundColor = 'var(--color-neutral-200)';

        // Remove blur from all slides
        slides.forEach(slide => {
            const glass = slide.slide.querySelector('.carousel-features__glass');
            if (glass) {
                glass.classList.remove('is-blurred');
            }
        });
    });
}
